"use client"

import * as X from "@/ui"

import HeroMobileFrontImage from "@/assets/traveler-home-hero-mobile-front.png";
import HeroDesktopFrontImage from "@/assets/traveler-home-hero-desktop-front.png";
import HeroDesktopBackXlImage from "@/assets/traveler-home-hero-desktop-back-xl.jpg";

import ZapptaxIcon from "@/assets/shared-zapptax-icon-yellow.svg";

import ReactMarkdown from "react-markdown";
import { useTravelerHomePage } from "@/providers/strapi/content/types/singleTypes/traveler-home-page";


export function HeroSection(props: X.PageProps<{
  onDownloadApp: () => void;
}>) {
  return (
    <section className="scroll-mt-0 relative w-full overflow-hidden pb-[1.4vw] xl:pb-[22px] xl:h-[750px]">
      <Mobile {...props} />

      {/* desktop-only bg */}
      <X.Image
        src={HeroDesktopBackXlImage}
        alt="Hero Background"
        priority
        className={X.clsx(
          X.desktopOnly("block"),
          "w-full h-full object-cover object-center",
        )}
      // unoptimized={true}
      />

      {/* desktop-only front image */}
      <div className={X.clsx(
        X.desktopOnly("block"),
        "absolute h-auto",
        //"w-[29vw] right-[7.5vw] top-[10vw]",
        "right-[calc((100%-1232px)/2)]", // align to right edge of max-w-content
        "top-[150px]", // adjust as needed for vertical placement
        "w-[500px]", // fixed width (adjust as needed)
      )}>
        <X.Image
          src={HeroDesktopFrontImage}
          alt="Hero Foreground"
          priority
          fetchPriority="high"
          className={X.clsx(
            "absolute top-0 right-0",
            "rounded-2xl border border-white h-[600px] w-auto",
          )}
        // unoptimized={true}
        />
        <X.Image
          src={ZapptaxIcon}
          alt="Zapptax"
          priority
          className={X.clsx(
            "absolute top-6 right-6 w-[32px] h-auto"
          )}
          unoptimized={true}
        />
      </div>

      {/* desktop-only text */}
      <div className={X.clsx(
        X.desktopOnly("block"),
        "absolute inset-0 pt-header-desktop",
      )}>
        <div className={X.clsx(
          "max-w-content mx-auto h-[100%]",
          "flex flex-col justify-center items-stretch",
        )}>
          <div className="w-[740px]">
            <TextContent
              locale={props.locale}
              onDownloadApp={props.onDownloadApp}
            />
          </div>
        </div>
      </div>
    </section>
  );
}


function Mobile(props: X.PageProps<{
  onDownloadApp: () => void;
}>) {
  return (
    <div className={X.clsx(
      X.mobileOnly(),
      "w-full mb-12",
      "bg-gradient-to-b from-[#f7f6f9] to-[#bec3cf]",
      "pt-header-mobile px-mobile-margin",
    )}>
      <TextContent
        locale={props.locale}
        onDownloadApp={props.onDownloadApp}
      />

      <X.Image
        src={HeroMobileFrontImage}
        alt="Hero Foreground"
        priority
        fetchPriority="high"
        className="w-full max-w-[440px] mx-auto h-auto translate-y-12 border border-white rounded-4xl -mt-6"
      />
    </div>
  );
}


function TextContent(props: X.PageProps<{
  onDownloadApp: () => void;
}>) {
  // const tr = X.useTranslator();
  const downloadUrl = X.useDownloadUrl(props.locale);


  // const content: Record<string, SingleTypes> | null = useContext(ContentContext);
  // if (!content) throw new Error('hero content not found')
  // const { hero } = content['traveler'] as TravelerHomePage;
  // if (!hero) throw new Error('hero content not found')
  const hero = useTravelerHomePage('hero')



  // const downloadLabel = tr({
  //   en: hero.downloadAppCTA,
  //   fr: hero.downloadAppCTA
  // });

  return (
    <>
      <h1 className={X.clsx(
        "leading-tight",
        "text-center text-[35px] mb-6 mt-6",
        "xl:text-start xl:text-[64px] xl:mb-8 xl:mt-0 [&_strong]:font-semibold",
      )}>
        <ReactMarkdown >
          {hero.tagLine}
        </ReactMarkdown>
        {/* {tr({
          en: <><strong>Don't leave your VAT</strong> behind</>,
          fr: <>La détaxe, <strong>aussi simple que votre shopping</strong></>
        })} */}
      </h1>
      {/* <p className={X.clsx(
        "text-center text-[16px] xl:text-start xl:text-[24px] mb-6 xl:mb-10",
      )}>
        {hero.content}
        {tr({
          en: "From shopping to refund, everything happens in the app. Just scan, validate, and get your VAT back before leaving the EU",
          fr: "Libérez-vous l'esprit, notre application vous simplifie le remboursement de la TVA",
        })}
      </p> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <p {...props} className={X.clsx(
          "text-center text-[16px] xl:text-start xl:text-[24px] mb-6 xl:mb-10",
        )} />
      }}>
        {hero.content}
      </ReactMarkdown>

      <div className={X.clsx(
        X.mobileOnly(),
        "flex flex-col items-center xl:items-start",
      )}>
        <X.Button
          primary
          exitHref={downloadUrl}
          label={hero.downloadAppCTA}
          lg
        />
      </div>

      <div className={X.clsx(
        X.desktopOnly("flex"),
        "flex-col items-center xl:items-start",
      )}>
        <X.Button
          primary
          onClick={props.onDownloadApp}
          label={hero.downloadAppCTA}
          lg
        />
      </div>
    </>
  );
}
